import React from "react";
import "./DashboardHeader.css";

import { useSelector } from "react-redux";
import { selectUsername } from "../../app/slices/UserSlice";
import PiBreadcrumbs, { BreadcrumbItem } from "../../components/PiBreadcrumbs";
import { Grid } from "@mui/material";
import PiHelpButton from "../onboarding/PiHelpButton";
type DashboardHeaderProps = {
  breadcrumbs: BreadcrumbItem[];
  children?: JSX.Element;
} & (
  | { compact?: false; subtitle: string }
  /** Breadcrumb-only header for task screens (no greeting); help sits on the breadcrumb row. */
  | { compact: true; subtitle?: undefined }
);

export default function DashboardHeader(props: DashboardHeaderProps) {
  const username = useSelector(selectUsername);

  if (props.compact) {
    return (
      <div
        id={"dashboard-header"}
        className="dashboardheader-root dashboardheader-compact"
        data-testid="dashboard-header"
      >
        <PiBreadcrumbs breadcrumbs={props.breadcrumbs} />
        <div className="dashboardheader-children">
          <PiHelpButton testId="dashboard-help" />
          {props.children}
        </div>
      </div>
    );
  }

  return (
    <div id={"dashboard-header"} className="dashboardheader-root" data-testid="dashboard-header">
      <Grid container>
        <Grid item>
          <PiBreadcrumbs breadcrumbs={props.breadcrumbs} />
        </Grid>
      </Grid>
      <Grid container className="dashboardheader-body" wrap="wrap">
        <Grid item xs={12} sm={7} md={10}>
          <div>
            <div className="dashboardheader-greeting-title ">
              Hey, {username}
            </div>
            <div className="dashboardheader-greeting-subtitle">
              {props.subtitle}
            </div>
          </div>
        </Grid>
        <Grid item xs={5} sm={3} md={2}>
          <div className="dashboardheader-children">
            {/* Help sits where help usually is: top right, beside the CTA. */}
            <PiHelpButton testId="dashboard-help" />
            {props.children}
          </div>
        </Grid>
      </Grid>
    </div>
  );
}
